import React from 'react'
import { useNavigate } from 'react-router-dom'
import { LanguageSwitcher } from '../../components/common/LanguageSwitcher'
import { useDocumentTitle } from '../../hooks'
import { useAuthStore } from '../../store/auth.store'
import './NotFoundPage.css'

/**
 * NotFoundPage Component
 * 404 error page
 */
export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate()
  const { isAuthenticated } = useAuthStore()

  // Set document title
  useDocumentTitle('pageTitles.notFound')

  const handleGoHome = () => {
    if (isAuthenticated) {
      navigate('/workspaces')
    } else {
      navigate('/login')
    }
  }

  return (
    <div className="not-found-page">
      <div className="not-found-page__language-switcher">
        <LanguageSwitcher />
      </div>
      <div className="not-found-page__content">
        <h1 className="not-found-page__title">404</h1>
        <h2 className="not-found-page__subtitle">Sahifa topilmadi</h2>
        <p className="not-found-page__message">
          Siz izlayotgan sahifa mavjud emas yoki boshqa joyga ko‘chirilgan.
        </p>
        <button className="not-found-page__button" onClick={handleGoHome}>
          {isAuthenticated
            ? 'Workspacelarga qaytish'
            : "Kirish sahifasiga o'tish"}
        </button>
      </div>
    </div>
  )
}
